import { render, staticRenderFns } from "./UnderApprovalNotification.vue?vue&type=template&id=3715e054&scoped=true"
import script from "./UnderApprovalNotification.vue?vue&type=script&lang=ts"
export * from "./UnderApprovalNotification.vue?vue&type=script&lang=ts"
import style0 from "./UnderApprovalNotification.vue?vue&type=style&index=0&id=3715e054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715e054",
  null
  
)

export default component.exports